<template>
    <div style="height: 100%">
        <div id="main" v-show="!rotaAninhada">
            <container-loader v-if="isLoading && !$store.getters.isLoading" />
            <div class="page">
                <div class="feriados vertical-flow">
                    <div class="listing-header">
                        <div class="title-breadcrumb">
                            <h1 class="title">{{ $t('feriados') }}</h1>
                            <nav class="breadcrumb" aria-label="breadcrumbs">
                                <ul>
                                    <li>
                                        <a class="a-inativo">{{ $t($route.meta.contexto) }}</a>
                                    </li>
                                    <li>
                                        <a class="a-inativo">{{ $t('cadastros') }}</a>
                                    </li>
                                    <li>
                                        <a aria-current="page">{{ $t('feriados') }}</a>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                        <div class="header-buttons">
                            <button
                                v-if="permissao.create"
                                class="save-btn"
                                type="button"
                                tag="button"
                                @click="
                                    $router.push({
                                        name: `${abrev}-feriados-new`,
                                    })
                                "
                            >
                                {{ $t('adicionar') }}
                            </button>
                        </div>
                    </div>

                    <div class="search-and-filter">
                        <div class="search-bar">
                            <search-bar :onSearch="debouncedOnSearch" />
                        </div>
                    </div>

                    <div class="feriados-table registry-wrapper">
                        <empty-table-message v-if="isEmpty" />
                        <b-table
                            v-else
                            :data="feriados"
                            class="data-table"
                            @sort="updateSort"
                            backend-sorting
                            backend-pagination
                        >
                            <b-table-column
                                v-for="(f, i) in fields"
                                :key="i"
                                :field="f.key"
                                :label="
                                    f.key != 'excluir' ? (f.label ? $t(f.label) : $t(f.key)) : ''
                                "
                                :width="f.width"
                                :class="f.key"
                                :sortable="f.sortable"
                                :custom-sort="f.sortFn"
                                v-slot="props"
                            >
                                <div v-if="f.key == 'situacao'">
                                    <ButtonUpdateStatus
                                        :service="service"
                                        :record="'feriado'"
                                        :item="props.row"
                                        :identifier="props.row.descricao"
                                        :canDelete="permissao.delete"
                                        @loadData="carregarDados(pagination.currentPage)"
                                    />
                                </div>
                                <div v-else-if="f.key == 'descricao'">
                                    <router-link
                                        :to="{
                                            name: `${abrev}-feriados-edit`,
                                            params: { id: props.row.id },
                                        }"
                                    >
                                        <pre>{{ props.row[f.key] }}</pre>
                                    </router-link>
                                </div>
                                <div v-else-if="f.key == 'data'">
                                    {{ props.row[f.key] | moment('L') }}
                                </div>
                                <div v-else>
                                    {{ props.row[f.key] }}
                                </div>
                            </b-table-column>
                        </b-table>
                    </div>
                    <PaginationViewer
                        class="mb-0"
                        :resetPagination="pagination.resetPagination"
                        :totalItems="pagination.totalRows"
                        :perPageOptions="pagination.perPageOptions"
                        :optionStarted="pagination.optionStarted"
                        @change="updatePagination"
                    />
                </div>
            </div>
        </div>
        <router-view />
    </div>
</template>

<script>
import FeriadosService from '@/services/FeriadosService';
import ContainerLoader from '@/components/content/loader/ContainerLoader';
import ButtonUpdateStatus from '@/components/shared/buttons/ButtonUpdateStatus.vue';

export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name.includes('feriados') && !to.name.includes('feriados-list')) {
            this.rotaAninhada = true;
        } else {
            this.rotaAninhada = false;
            this.carregarDados(this.pagination.currentPage);
        }
        next();
    },
    components: {
        ContainerLoader,
        ButtonUpdateStatus,
    },
    data() {
        return {
            rotaAninhada: false,
            feriados: [],
            service: new FeriadosService(this.$http, this.$router),
            fields: [
                { key: 'descricao', width: null, sortable: true, sortFn: null },
                {
                    key: 'data',
                    width: 140,
                    sortable: true,
                    sortFn: this.sortData,
                },
                { key: 'situacao', width: 80, sortable: false, sortFn: null },
            ],
            isLoading: true,
            isEmpty: false,
            deleteThis: {},
            debouncedOnSearch: null,
            sort: 'data',
            order: 'asc',
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            abrev: '',
            isVenda: this.$route.meta.contexto == 'vendas',
            isDespesa: this.$route.meta.contexto == 'despesas',
            isPromotor: this.$route.meta.contexto == 'promotor',
            isAgro: this.$route.meta.contexto == 'agro',
        };
    },
    created() {
        if (this.$route.name.includes('feriados') && !this.$route.name.includes('feriados-list')) {
            this.rotaAninhada = true;
        } else {
            this.rotaAninhada = false;
        }

        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];
        this.abrev = this.$route.meta.contexto;

        if (this.isVenda) {
            this.permissao = this.hasPermissionAccess('vendas', 'empresa', 'vendas-feriados');
        } else if (this.isPromotor) {
            this.permissao = this.hasPermissionAccess('promotor', 'cadastros', 'promotor-feriados');
        } else if (this.isDespesa) {
            this.permissao = this.hasPermissionAccess('despesas', 'empresa', 'des-feriado');
            this.abrev = 'des';
        } else if (this.isAgro) {
            this.permissao = this.hasPermissionAccess('agro', 'empresa', 'agro-feriados');
            this.abrev = 'agro';
        }

        if (!this.permissao.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'feriados' },
            });
        } else {
            this.debouncedOnSearch = this.debounce(this.onSearch, 500);
            this.carregarDados();
        }
    },
    methods: {
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.carregarDados(1);
        },
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;
            this.isLoading = true;
            this.service
                .findAll(
                    this.sort,
                    this.order,
                    currentPage - 1,
                    this.pagination.perPage,
                    this.queryFilter
                )
                .then(this.mapItems)
                .then((feriados) => {
                    this.feriados = feriados;
                    this.isEmpty = this.feriados.length <= 0;
                })
                .catch((e) => {
                    this.isEmpty = this.feriados.length <= 0;
                    console.error('Ocorreu algum erro: ', { e });
                })
                .finally(() => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;
            let feriados = body.content.map((f) => {
                return {
                    id: f.idferiado,
                    idferiado: f.idferiado,
                    descricao: f.descricao,
                    data: f.data,
                    login: f.login,
                    excluir: 'excluir-feriados',
                    situacao: f.situacao,
                };
            });
            return feriados;
        },
        updateSort(sort, order) {
            this.sort = sort;
            this.order = order;
            this.carregarDados();
        },
        parseDateString(d) {
            let a = d.split('-');

            return new Date(a[0], a[1] - 1, a[2]).toLocaleDateString();
        },
        sortData(a, b, isAsc) {
            let da = a['data'].split('/').reverse().join('-');
            let db = b['data'].split('/').reverse().join('-');

            if (isAsc) {
                return new Date(da).getTime() - new Date(db).getTime();
            } else {
                return new Date(db).getTime() - new Date(da).getTime();
            }
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: 100%;

    .page {
        position: relative;
        padding-left: 0;
    }

    .feriados .search-and-filter {
        display: flex;
        justify-content: space-between;
        margin: 10px 0;
    }

    .feriados .search-and-filter .search-bar {
        width: 100%;
    }

    .feriados .search-and-filter .filter-bar {
        width: 31%;
    }
}
</style>
